import React, {Component} from 'react';

import axios from 'axios';

import Settings from '../../shared/settings'

// TRANSLATE
import { translate } from 'react-i18next';

// STYLES
import styled from 'styled-components';

// COMPONENTS
import Loading from '../../components/loading/loading.component';
import Notes from '../../components/notes/notes.component';

// CONTAINERS
import Banner from '../../containers/Banner/banner.container'
import About from '../../containers/About/about.container';

class DetailsProducts extends Component {
    constructor(){
        super();
        this.state = {
            status: 0,
            data: '',
            dataToBanner: '',
            dataToAbout: '',
            dataToMainDishes: '',
        }
    }

    componentDidMount () {
        this.loadData()
    }

    componentWillUpdate(){
        const slug = this.props.match.params.slug;
        const requestLang = window.location.pathname.split('/');
        let lang = requestLang[1];

        if (lang !== this.props.i18n.language) {
            let url = '/'+this.props.i18n.language+'/'+this.props.t('produtos')+'/'+slug;
            this.props.history.replace(url, true)
        }
    }

    loadData(){
        const {
            i18n
        } = this.props;

        const slug = this.props.match.params.slug;
        let url = Settings.server+'/api/v1/product/'+slug+'?expand=menus,timetables,media,producers,certifiers&lang='+i18n.language;
        
        axios.get(url)
        .then(
            res => {
                this.setState({
                    dataToBanner: {
                        name: res.data.name,
                        description: res.data.description,
                        banner: res.data.media[4][0], 
                        qualification: res.data.qualification
                    },
                    dataToAbout: {
                        description_historic: res.data.description_historic ? res.data.description_historic : null,
                        description_technic: res.data.description_technic ? res.data.description_technic : null,
                        production_method: res.data.production_method ? res.data.production_method : null,
                        production_season: res.data.production_season ? res.data.production_season : null,
                        annual_production: res.data.annual_production ? res.data.annual_production : null,
                        geo_area: res.data.geo_area ? res.data.geo_area : null,
                        details_organoleptic: res.data.details_organoleptic ? res.data.details_organoleptic : null,
                        allergenics: res.data.allergenics ? res.data.allergenics : null,
                        conservation: res.data.conservation ? res.data.conservation : null,
                        notebook_specs: res.data.notebook_specs ? res.data.notebook_specs : null,
                        details_specific: res.data.details_specific ? res.data.details_specific : null,
                        legislation_newspaper: res.data.legislation_newspaper ? res.data.legislation_newspaper : null,
                        legislation_dr: res.data.legislation_dr ? res.data.legislation_dr : null,
                        region: res.data.region ? res.data.region : null,
                        media: res.data.media ? res.data.media : null,
                        producers: res.data.producers ? res.data.producers : null,
                        certifiers: res.data.certifiers ? res.data.certifiers : null
                    },
                    status: 1
                })
            }
        )
        .catch(
            err => {
                this.setState({
                    status: 2
                }, () => {
                    let path = this.props.match.path;
                    let url = path.replace('/:slug','');
                    this.props.history.push(url+'/404', url);
                })
            }
        )
    }

    render() {
        const {
            status,
            dataToBanner,
            dataToAbout
        } = this.state;

        const {t} = this.props;

        return(
            <DetailsPage>
                {
                    status === 0 &&
                        <SectionLoading>
                            <Loading/>
                        </SectionLoading>
                }
                {
                    status === 1 &&
                        <DetailsMaster>
                            <Banner type="1" t={t} data={dataToBanner}/>
                            <DetailsContent>
                            <About type="1" t={t} data={dataToAbout} qr url={window.location.href} img={dataToBanner.banner}/>
                            <Notes t={t} type="product_details"/>
                            </DetailsContent>
                                {/*
                                
                                    <RelatedProducts type="1" t={t}/>
                                    <RelatedReceips type="1" t={t}/>
                                
                                */}
                        </DetailsMaster>
                }
            </DetailsPage>
        )
    }
}

export default translate('translations')(DetailsProducts);

// STYLES PAGE
const SectionLoading  = styled.div `
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: white;
    z-index: 1000000000;
    display: flex;
    align-items: center;
`
const DetailsPage = styled.div `
`;
const DetailsMaster = styled.div `
`;
const DetailsContent = styled.div `
    padding-top: 70px;
`;



// WEBPACK FOOTER //
// ./src/pages/detailsProducts/detailsProducts.page.js